const strEmpty = str => {
  if (str.trim() === '') return true;
  return false;
};

export default strEmpty;
